import { Layout } from 'antd';

import styled from 'styled-components';

import {
    transactionTableBaseStyles,
    transactionContentBaseStyles,
} from '@components/Transactions/TransactionListStyles';

export const BillingLayout = styled(Layout)`
    margin-left: 400px;
`;

export const StatementSearchResultsContainer = styled.div`
    ${transactionTableBaseStyles}

    .ant-table-summary {
        td {
            border-top: 2px solid ${(props) => props.theme.PrimaryColor} !important;
            box-shadow: inset 0 2px 0 ${(props) => props.theme.PrimaryColor};
        }

        .statement-summary-title {
            text-transform: uppercase;
            padding: 0.5rem 0.75rem;
        }
        .statement-summary-amount-cell {
            text-transform: uppercase;
            padding: 0.5rem 0.75rem;
            line-height: 1.3em;
        }
        .summary-icon-wrapper {
            color: ${(props) => props.theme.TextColor};
            font-size: 1.25rem;
            line-height: 1;
            opacity: 0.5;
            padding-top: 0.75rem;
            text-align: center;
        }
    }
`;

export const SearchHeader = styled.div`
    margin: 0;
    padding: 0;
    position: relative;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 1em 2em;
    font-size: 0.9rem;
    margin-bottom: 1rem;

    @media only screen and (max-width: 960px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .header-summary {
        min-height: 3rem;
        border-right: 1px solid #e8e8e8;
        flex: auto 0 0;
        padding: 0.5rem 2rem 0 0;

        @media only screen and (max-width: 960px) {
            border-right: none;
            min-height: 0;
            padding: 0;
        }

        .header-summary-text {
            display: flex;
            align-items: center;
            text-transform: uppercase;

            em.counter {
                font-size: 1.6rem;
                font-weight: bold;
                font-style: normal;
                padding-right: 0.5em;
            }
        }
        small.hidden-models {
            display: block;
            //text-align: center;
        }
    }

    .header-filters {
        min-height: 3rem;
        // border-right: 1px solid #e8e8e8;
        flex: 1 0 0;
        padding: 0 1rem 0 3rem;
    }

    div.control {
        padding: 0.5rem 0;
        max-width: 20rem;
        span.label {
            font-size: 0.85em;
            text-transform: uppercase;
            padding: 0 0.5em 0 0;
        }
    }
`;

export const SearchResultList = styled.div`
    ${transactionContentBaseStyles}

    position: relative;
    padding: 0.5rem 0;
    width: 100%;
    @media only screen and (max-width: 920px) {
        width: 100%;
        border-right: none;
    }
`;
